<template>
  <div>
    <v-alert color="info" dense text>
      O valor percentual será aplicado sobre o valor total.
    </v-alert>
    <v-text-field
      v-model="price"
      label="Valor percentual"
      type="number"
      :min="0.01"
      :step="0.01"
      :max="100"
      outlined
      dense
      suffix="%"
      :rules="[
        (v) => !!v || 'Valor percentual é obrigatório',
        (v) => parseFloat(v) > 0 || 'Valor percentual deve ser maior que 0',
        (v) =>
          parseFloat(v) <= 100 ||
          'Valor percentual deve ser menor ou igual a 100',
      ]"
      hide-details="auto"
    />
  </div>
</template>

<script>
export default {
  name: "Fixed",
  props: {
    value: {
      type: Object,
      default: () => ({
        value: 0,
      }),
    },
  },
  computed: {
    price: {
      get() {
        return this.value?.value ?? 0;
      },
      set(value) {
        this.$emit("input", {
          ...(this.value || {}),
          value: parseFloat(value),
        });
      },
    },
  },
  mounted() {
    this.price = this.price;
  },
};
</script>